import { Tags } from "@/enum/tags";

import { apiSlice } from "../http";
import {
  PriceRemarkAuditEntry,
  PriceRemarkParameter,
  UpdateParametersPayload,
} from "./types";

export const priceRemarkParametersApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPriceRemarkParameters: builder.query<PriceRemarkParameter[], void>({
      query: () => ({ url: "/price-remark/parameters", method: "GET" }),
      transformResponse: (response: PriceRemarkParameter[]) => response || [],
      providesTags: [Tags.PRICE_REMARK_PARAMETERS],
    }),
    updatePriceRemarkParameters: builder.mutation<
      PriceRemarkParameter[],
      UpdateParametersPayload
    >({
      query: (body) => ({
        url: "/price-remark/parameters",
        method: "PATCH",
        body,
      }),
      invalidatesTags: [Tags.PRICE_REMARK_PARAMETERS],
    }),
    getPriceRemarkParametersAudit: builder.query<
      { data: PriceRemarkAuditEntry[]; total: number },
      { page?: number; limit?: number } | void
    >({
      query: (args) => {
        const params = new URLSearchParams();
        if (args?.page) params.set("page", String(args.page));
        if (args?.limit) params.set("limit", String(args.limit));
        return {
          url: `/price-remark/parameters/audit?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: [Tags.PRICE_REMARK_PARAMETERS],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetPriceRemarkParametersQuery,
  useUpdatePriceRemarkParametersMutation,
  useGetPriceRemarkParametersAuditQuery,
} = priceRemarkParametersApi;
